module.exports = __webpack_public_path__ + "img/7.710a6064.jpg";